<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getInfo">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="backUrl">
      </f7-nav-left>
      <f7-nav-title></f7-nav-title>
      <f7-nav-right>
        <f7-link
          icon="cicon-tongzhi"
          :href="`/project/msgList/${projectId}?title=${project.name}`">
      </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="project-info-sub-title">
      <div class="project-info-name">
        <div class="project-info-status">
          {{ project.projectStatusDesc }}
        </div>
        <div style="padding-left: 0.5rem;">
          <div>{{ project.name }}</div>
          <div style="display: flex;" v-if="project.path && project.path.length > 0">
            <div>
              <div
                v-for="(st, index) in project.path"
                :key="st"
                v-show="project.pathDisplay
                 || (index === project.path.length - 1)">
                |&nbsp;&nbsp;{{ st }}
              </div>
            </div>
            &nbsp;
            <div style="cursor: pointer;" @click="project.pathDisplay=!project.pathDisplay">
              <f7-icon
                :material="project.pathDisplay?'arrow_drop_up':'arrow_drop_down'">
              </f7-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="has-content-margin" style="padding: 0.5rem 0rem;">
      <f7-link :href="forwardDetail">
        <div class="content-text">
          <f7-row no-gap>
            <f7-col style="border-right: 0.05rem dashed #e1e1e1">
              <div>
                <div>
                  <span class="primary-text">{{ project.projectSize | formatNumberVal }}</span>
                </div>
                <div class="label-text">
                  工程规模
                  <span v-if="project.sizeUnitDesc">({{ project.sizeUnitDesc }})</span>
                </div>
              </div>
              <div style="padding-top: 0.8rem;">
                <div class="minor-text"></div>
                <div>
                  <span class="primary-text"></span>
                  <span class="minor-text">
                    {{ project.startupTime | formatDateValue }}
                     至
                    {{ project.completedTime | formatDateValue }}
                  </span>
                </div>
                <div class="minor-text">{{ project.dutyCompanyName }}</div>
              </div>
            </f7-col>
            <f7-col>
              <div style="display: flex; justify-content: space-around;">
                <div style="width: 50%">
                  <div>
                    <span class="primary-text">{{ project.prePrice | formatPriceVal }}</span>
                  </div>
                  <div class="label-text">
                    分包单价
                    <span v-if="project.priceUnitDesc">({{ project.priceUnitDesc }})</span>
                  </div>
                </div>
                <div style="width: 50%;">
                  <div>
                    <span class="primary-text">{{ project.needUserNumber || '--' }}</span>
                  </div>
                  <div class="label-text">所需人数</div>
                </div>
              </div>
              <div style="padding-top: 0.8rem; display: flex; justify-content: space-around;">
                <div style="width: 50%">
                  <div>
                    <span class="primary-text">
                      <span :style="project.remainTime >=0 ? '': 'color: red;'">
                        <span>{{ project.remainTime >=0 ? '': '延期' }}</span>
                        <span>{{ Math.abs(project.remainTime) }}</span>
                      </span>
                    </span>
                  </div>
                  <div class="label-text">剩余工期(天)</div>
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; justify-content: center;">
                  <div class="primary-text" style="display: flex; align-items: center;">
                    <img src="@/assets/img/level.png"
                    style="margin-right: 0.2rem; width: 1.05rem; height: 1.35rem;"/>
                    {{ project.qualityStandardDesc || '' }}
                  </div>
                </div>
              </div>
            </f7-col>
          </f7-row>
        </div>
      </f7-link>
      <div style="padding: 0.5rem 0.5rem 0rem 0.5rem; font-size: 0.6rem; display: flex;">
        <div class="tags tags-text" style="flex: auto;">
          管理人员：{{ managerNames }}
        </div>
        <f7-link :href="'/project/manager/'+projectId">
          <div class="button-config">设置</div>
        </f7-link>
      </div>
    </div>
    <div class="base-info">
      <div class="has-content-margin" style="padding: 0.5rem 0rem;">
        <div>
          <div class="assign">
            <div class="assign-label">施工队伍</div>
            <div class="assign-text">
              {{
                project.receptCompany
                && project.receptCompany.name
                && project.receptCompany.name !== '' ?
                '已分派' : '待分派'
              }}
            </div>
            <div class="assign-fill"></div>
            <div class="assign-date">
              分派时间：{{ (project.receptCompany || {}).date | formatDateValue }}
            </div>
          </div>
          <div class="assign">
            <span>{{ (project.receptCompany || {}).name }}</span>
          </div>
        </div>
        <div style="padding: 0.5rem 0.5rem 0rem 0.5rem;">
          <div class="divider-line">&nbsp;</div>
        </div>
        <div>
          <div class="assign">
            <div class="assign-label">验收进度</div>
            <!-- <div class="assign-text-accept">
              {{
                project.acceptanceDetail ?
                project.acceptanceDetail.statusDesc : '未申请'
              }}
            </div> -->
            <div class="assign-fill"></div>
            <div class="assign-date">
              报验时间：{{ (project.acceptanceDetail || {}).date | formatDateValue }}
            </div>
          </div>
          <div class="assign">
            <div>最新验收：</div>
            <div>{{ (project.acceptanceDetail || {}).title }}</div>
          </div>
          <div class="assign">
            <div>验收情况：</div>
            <div>
              <f7-icon
                size="0.6rem"
                :icon="(project.acceptanceDetail || {}).security === 'agree' ?
                  'cicon-dui' : 'cicon-cuo'"
                :class="(project.acceptanceDetail || {}).security === 'agree' ?
                  'icon-passed' : 'icon-nopassed'">
              </f7-icon>
              安全
            </div>
            <div>
              &nbsp;&nbsp;
              <f7-icon
                size="0.6rem"
                :icon="(project.acceptanceDetail || {}).quality === 'agree' ?
                  'cicon-dui' : 'cicon-cuo'"
                :class="(project.acceptanceDetail || {}).quality === 'agree' ?
                  'icon-passed' : 'icon-nopassed'">
              </f7-icon>
              质量
            </div>
            <div>
              &nbsp;&nbsp;
              <f7-icon
                size="0.6rem"
                :icon="(project.acceptanceDetail || {}).composite === 'agree' ?
                  'cicon-dui' : 'cicon-cuo'"
                :class="(project.acceptanceDetail || {}).composite === 'agree' ?
                  'icon-passed' : 'icon-nopassed'">
              </f7-icon>
              综合
            </div>
            <div>
              &nbsp;&nbsp;
              <f7-icon
                size="0.6rem"
                :icon="(project.acceptanceDetail || {}).quantity === 'agree' ?
                  'cicon-dui' : 'cicon-cuo'"
                :class="(project.acceptanceDetail || {}).quantity === 'agree'?
                  'icon-passed' : 'icon-nopassed'">
              </f7-icon>
              预算
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-area">
      <div class="menu-row">
        <f7-link
          :href="`/project/assign/${projectId}`">
          <div class="link-menu">
            <img src="@/assets/img/xuanzeduiwu.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">选择队伍</div>
          </div>
        </f7-link>
        <f7-link @click="callStartWork">
          <div class="link-menu">
            <img src="@/assets/img/kaigong.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">开工</div>
          </div>
        </f7-link>
        <f7-link @click="callProjectAttendance">
          <div class="link-menu">
            <img src="@/assets/img/renwukaoqin.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">实名考勤</div>
          </div>
        </f7-link>
        <f7-link :href="`/workLog/log/${projectId}?name=${
          project.path && project.path.length > 0 ?
          project.path[project.path.length - 1] : (project.name || '')}`">
          <div class="link-menu">
            <img src="@/assets/img/shigongrizhi_s.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">施工日志</div>
          </div>
        </f7-link>
      </div>
      <div style="height: 1rem;"></div>
      <div class="menu-row">
        <f7-link :href="`/acceptance/list/${projectId}?name=${
          project.path && project.path.length > 0 ?
          project.path[project.path.length - 1] : (project.name || '')}`">
          <div class="link-menu">
            <img src="@/assets/img/yanshou.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">验收</div>
          </div>
        </f7-link>
        <f7-link :href="`/rewardPunish/list/${projectId}`">
          <div class="link-menu">
            <img src="@/assets/img/jiangfa.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">奖罚</div>
          </div>
        </f7-link>
        <f7-link :href="`/project/evaluate/${projectId}`">
          <div class="link-menu">
            <img src="@/assets/img/pingjiashangji.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">评价上级</div>
          </div>
        </f7-link>
        <!-- <f7-link :href="#">
          <div class="link-menu">
            <img src="@/assets/img/anquanjiaoyu.png" style="width: 2rem; height: 2rem;">
            <div style="padding-top: 0.5rem;">安全教育</div>
          </div>
        </f7-link> -->
        <div style="width: 4.5rem; height: 4.5rem;">
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import currency from 'currency.js';
import { toStartWork, toAttendance } from '@/util/native';
import { createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getProject, validStartWork } from '@/api/project/project';

export default {
  props: ['projectId'],
  data() {
    return {
      project: {},
      perms: {},
    };
  },
  mounted() {
    this.getInfo();
  },
  filters: {
    formatDateValue: value => dateFormat(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
    formatPriceVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '面议';
    },
  },
  computed: {
    backUrl() {
      if (this.project.type === 'rootProject') {
        return '/home';
      }
      return `/project/tree/${this.$f7route.query.rootId}`;
    },

    forwardDetail() {
      let url = '/home';
      const rootId = this.$f7route.query.rootId;
      const parentId = this.project.parentId || this.project.id;
      if (this.project.type === 'rootProject') {
        url = `/project/add/${this.project.id}`;
      } else if (this.project.type === 'normalProject') {
        url = `/project/split/${this.project.id}?title=拆分任务&parentId=${parentId}&rootId=${rootId}`;
      } else if (this.project.type === 'assistProject') {
        url = `/project/addAssist/${this.project.id}?title=辅助任务&parentId=${parentId}&rootId=${rootId}`;
      } else {
        url = `/project/add/${this.project.id}`;
      }
      return url;
    },
    managerNames() {
      return [].concat(
        this.project.dutyInfo && this.project.dutyInfo.projectManager ?
          this.project.dutyInfo.projectManager : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.deputyProjectManager ?
            this.project.dutyInfo.deputyProjectManager : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.techLeader ?
            this.project.dutyInfo.techLeader : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.professionLeader ?
            this.project.dutyInfo.professionLeader : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.qualityInspector ?
            this.project.dutyInfo.qualityInspector : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.safeInspector ?
            this.project.dutyInfo.safeInspector : [])
        .concat(
          this.project.dutyInfo && this.project.dutyInfo.forecastInspector ?
            this.project.dutyInfo.forecastInspector : [])
        .map(item => item.name)
        .join(', ');
    },
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getInfo()]).then(() => done());
    },
    getInfo() {
      getProject({ projectId: this.projectId }).then((result) => {
        this.project = Object.assign({ pathDisplay: false }, result.data);
        this.perms = result.perms || {};
      });
    },
    callStartWork() {
      if (!this.perms.projectStartWork) {
        createToast(this, '您无权限开工');
        return;
      }
      validStartWork({ projectId: this.projectId || '' }).then((result) => {
        if (result.code === 0) {
          toStartWork(this.projectId || '', this.project.isSignedContract || '');
        }
      });
    },
    callProjectAttendance() {
      toAttendance(this.projectId || '');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .project-info-name {
    display: flex;
    align-items: center;
    padding: 0rem 0rem 1rem 0.5rem;
  }

  .project-info-status {
    text-align: center;
    background: $white-color;
    border-radius: 3rem;
    min-width: 3rem;
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    color: $theme-color;
  }

  .project-info-sub-title {
    margin-top: -1px;
    padding-top: 1px;
    background-color: $theme-color;
    color: $white-color;
  }

  .content-text {
    text-align: center;
  }

  .primary-text {
    color: $theme-color;
    font-size: 1.25rem;
  }

  .minor-text {
    color: $font-color;
    font-size: 0.6rem;
  }

  .label-text {
    color: $second-font-color;
    font-size: 0.6rem;
  }

  .tags {
    background-color: #DDEAFB;
    color: #333333;
    border-radius: 0.4rem;
    height: 1.5rem;
    line-height: 1.5rem;
    padding: 0rem 0.5rem;
    margin-right: 1rem;
  }

  .tags-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .button-config {
    background-color: #DDEAFB;
    color: #008BE6;
    border-radius: 0.4rem;
    height: 1.5rem;
    line-height: 1.5rem;
    padding: 0rem 0.8rem;
    min-width: 1.6rem;
    text-align: center;
  }

  .assign {
    padding: 0.2rem 1rem;
    color: #333333;
    display: flex;
    align-items: center;
  }

  .assign-label {
    font-weight: bold;
  }

  .assign-text {
    margin-left: 1rem;
    height: 1rem;
    line-height: 1rem;
    padding: 0rem 0.2rem;
    border: 0.05rem solid #FF9403;
    border-radius:0.3rem;
    font-size: 0.6rem;
  }

  .assign-text-accept {
    margin-left: 1rem;
    height: 1rem;
    line-height: 1rem;
    padding: 0rem 0.2rem;
    border: 0.05rem solid #5FAD2F;
    border-radius:0.3rem;
    font-size: 0.6rem;
  }

  .assign-fill {
    flex: auto;
  }

  .assign-date {
    color: #999999;
    font-size: 0.8rem;
  }

  .icon-passed {
    color: #4cd964;
  }

  .icon-nopassed {
    color: #ff3b30;
  }

  .icon-menu-botton {
    color: #007aff;
  }

  .divider-line {
    border-top: 0.05rem solid $border-color;
  }

  .menu-area {
     padding: 1rem 0.5rem;
     text-align: center;
  }

  .menu-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .link-menu {
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 1rem;
    background-color: $white-color;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/info.vue